import { MessageEnvelope } from '@cds/push';
import { pprops } from '@frontend/sports/common/core/utils/redux';
import { createAction, props } from '@ngrx/store';

import { PickId } from '../../core/picks/pick-id';
import { IPickSubscriptionPayload } from '../picks/pick-subscription-actions';
import { BetslipTeaserActions } from './actions';

export class BetslipTeaserCdsActions {
    static readonly ACTION_SCHEMA = `${BetslipTeaserActions.ACTION_SCHEMA}/cds`;

    private static readonly SUBSCRIBE_TO_PICK = `${BetslipTeaserCdsActions.ACTION_SCHEMA}/SUBSCRIBE_TO_PICK`;
    private static readonly UNSUBSCRIBE_FROM_PICK = `${BetslipTeaserCdsActions.ACTION_SCHEMA}/UNSUBSCRIBE_FROM_PICK`;
    private static readonly UNSUBSCRIBE_ALL = `${BetslipTeaserCdsActions.ACTION_SCHEMA}/UNSUBSCRIBE_ALL`;
    private static readonly EVENT_UPDATE = `${BetslipTeaserCdsActions.ACTION_SCHEMA}/EVENT_UPDATE`;

    static subscribeToPick = createAction(BetslipTeaserCdsActions.SUBSCRIBE_TO_PICK, pprops<IPickSubscriptionPayload>());
    static unsubscribeFromPick = createAction(BetslipTeaserCdsActions.UNSUBSCRIBE_FROM_PICK, props<{ pickId: PickId }>());
    static unsubscribeAll = createAction(BetslipTeaserCdsActions.UNSUBSCRIBE_ALL);
    static eventUpdate = createAction(BetslipTeaserCdsActions.EVENT_UPDATE, pprops<MessageEnvelope>());
}
